import "@fontsource/ibm-plex-sans/300.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/700.css";
import { createTheme } from "@mui/material";
export const defaultTheme = createTheme({
    typography: {
        fontFamily: `IBM Plex Sans, sans-serif`,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
    },
});
//# sourceMappingURL=defaultTheme.js.map